<template>
  <div class="mt-4 mb-12">
    <div class="lg:flex block">
      <SkeletonLoader
        v-if="!isOnInternalCmsPage"
        height="26px"
        width="400px"
        class="w-full lg:block hidden"
      />
      <SkeletonLoader
        height="26px"
        width="410px"
        class="w-full lg:hidden block mb-6"
        item-classes="mx-auto"
      />
      <SkeletonLoader
        height="38px"
        width="45%"
        item-classes="lg:ml-auto"
        class="w-full lg:block hidden"
      />
      <div class="lg:hidden grid grid-cols-2 gap-4 ml-6 px-4">
        <SkeletonLoader
          height="38px"
        />
        <SkeletonLoader
          height="38px"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">


export default defineComponent({
  name: 'SearchResultsTopSkeleton',
  setup() {

    const { isOnInternalCmsPage } = useIsPage();

    return {
      isOnInternalCmsPage,
    };
  
  },
});

</script>
